/** Best first. Tuned models live in the server's models folder (scripts/add-whisper-model.sh). */
export const WHISPER_MODELS = [
    { value: 'large-v3', label: 'large-v3: most accurate of OpenAI’s' },
    { value: 'turbo', label: 'turbo: several times faster, a little less accurate' },
    { value: 'large-v2', label: 'large-v2: older, sometimes better on some recordings' },
    { value: 'medium', label: 'medium: faster, clearly weaker for Lithuanian' },
    { value: 'small', label: 'small: fast, poor for Lithuanian' },
    { value: 'distil-large-v3.5', label: 'distil-large-v3.5: fast, English only' },
    {
        value: '/models/lt/agirdi',
        label: 'agirdi: turbo tuned on 10,000 hours of Lithuanian; fewest errors on phone calls, writes without capitals or punctuation',
        language: 'lt',
    },
];
/** faster-whisper's names for OpenAI's own models, short and full. */
const OPENAI_MODELS = new Set([
    ...['tiny', 'base', 'small', 'medium'].flatMap((size) => [size, `${size}.en`, `Systran/faster-whisper-${size}`, `Systran/faster-whisper-${size}.en`]),
    ...['large', 'large-v1', 'large-v2', 'large-v3'].flatMap((size) => [size, `Systran/faster-whisper-${size}`]),
    ...['distil-large-v2', 'distil-medium.en', 'distil-small.en', 'distil-large-v3'].flatMap((name) => [name, `Systran/faster-${name.replace('distil-', 'distil-whisper-')}`]),
    'distil-large-v3.5',
    'distil-whisper/distil-large-v3.5-ct2',
    'large-v3-turbo',
    'turbo',
    'mobiuslabsgmbh/faster-whisper-large-v3-turbo',
]);
/**
 * Whether a model takes the company's names and terms as a hint. OpenAI's
 * own models do. Models tuned on one language were trained without hints,
 * and a hint makes them write nonsense (agirdi did, on every test call), so
 * they get none.
 */
export const takesHints = (model) => OPENAI_MODELS.has(model);
